import React, { ComponentProps } from 'react';
import Typography from '@ui/Typography';
import { cx } from 'class-variance-authority';
import { variants, type TagVariants } from './Tag-variants';

export default function Tag({
  className,
  children,
  variant,
  ...rest
}: { children: React.ReactNode } & ComponentProps<'span'> & TagVariants) {
  return (
    <span
      {...rest}
      className={cx(
        className,
        variants({
          variant,
        })
      )}
    >
      <Typography variant="pXs" bold color="inherit">
        {children}
      </Typography>
    </span>
  );
}
